import shiftApi from '../../api/shift'
import moment from 'moment'

// initial state
const state = {
  shifts: [],
  viewedShift: null,
  currentUserCurrentShift: null,
  currentUserNextShift: null,
  currentUserLastShift: null,
  notes: [],
}

// getters
const getters = {
  currentUserClockableShift: (state) => {
    if (state.currentUserCurrentShift && state.currentUserCurrentShift.id) {
      return state.currentUserCurrentShift
    } else if (
      state.currentUserNextShift &&
      state.currentUserNextShift.id &&
      moment(state.currentUserNextShift.startDatetime).isBefore(moment(new Date).add(1, 'h'))
    ) {
      return state.currentUserNextShift
    } else {
      return null
    }
  },
  available: (state) => {
    const upForTrade = state.shifts
      .filter(s => s.tradePending)
      .sort(function(a,b) {
        return a.startDatetime - b.startDatetime
      })
    const avail = state.shifts
      .filter(s => !s.userId)
      .sort(function(a,b) {
        return a.startDatetime - b.startDatetime
      })

    return upForTrade.concat(avail)
  },
}

// actions
const actions = {
  getAll ({ commit }, userId) {
    shiftApi.getFromTo({ userId: userId }, shifts => {
      commit('setShifts', shifts)
    })
  },

  getList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.getList(params,
      shifts => {
        commit('setShifts', shifts.shifts)
        resolve(shifts)
      },
      err => {
        reject(err)
      })
    })
  },

  replaceShifts({ commit }, shifts) {
    // TODO: 
  },

  checkRestricted ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.checkRestricted(params, result => {
        resolve(result)
      },
        error => {
          reject({ verdict: false, message: 'server error' })
        })
    })
  },

  update ({ dispatch, commit }, idAndFields) {
    return new Promise((resolve, reject) => {
      shiftApi.update(idAndFields, shift => {
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
        error => {
          reject()
        })
    })
  },

  bulkEdit ({ commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.bulkEdit(params, shifts => {
        commit('updateShifts', shifts)
        resolve(shifts)
      },
      error => {
        reject(error)
      })
    })
  },

  getCurrentUserUpcoming ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      shiftApi.getUpcomingForCurrent(shifts => {
        commit('setCurrentUserCurrentShift', shifts.current)
        commit('setCurrentUserNextShift', shifts.next)
        commit('setCurrentUserLastShift', shifts.last)
        resolve(shifts)
      },
      error => {
        reject()
      })
    })
  },

  getCurrentUserPickupable ({ commit }) {
    return new Promise((resolve, reject) => {
      shiftApi.getCurrentUserPickupable(shifts => {
        resolve(shifts)
      },
      error => {
        reject()
      })
    })
  },

  getMonth ({ dispatch, commit }, dateInMilliseconds) {
    shiftApi.getMonth(dateInMilliseconds, shifts => {
      dispatch('setOwned', shifts.owned)
      dispatch('setAvailable', shifts.available)
      // setAvailable
    })
  },

  getShift ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.getShift(shiftId, shift => {
        dispatch('setViewedShift', shift)
        resolve(shift)
      },
      error => {
        reject(error)
      })
    })
  },

  getNotes ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.getNotes(params, notes => {
        dispatch('setShiftNotes', notes)
        resolve(notes)
      },
      error => {
        reject(error)
      })
    })
  },

  requestTrade ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.requestTrade(params, shift => {
        const message = `You've put the ${ shift.location } ${ shift.shiftRole } shift up for trade!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong trading that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  revokeTrade ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.revokeTrade(shiftId, shift => {
        const message = `You've taken the ${ shift.location } ${ shift.shiftRole } shift off trade.`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong reclaiming that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  trade ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.trade(params, shift => {
        const message = `You've requested to take ${ shift.location } ${ shift.shiftRole } shift!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong taking that shift trade...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  allowTrade ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.allowTrade(shiftId, shift => {
        const message = `Trade approved!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong allow that trade...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  refuseTrade ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.refuseTrade(shiftId, shift => {
        const message = `Trade denied!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong refusing that trade...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  approveChanges ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.approveChanges(shiftId, shift => {
        const message = `Client change requests approved!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve(shift)
      },
      error => {
        const message = `Something went wrong approving the changes...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject(error)
      })
    })
  },

  denyChanges ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      shiftApi.denyChanges(shiftId, shift => {
        const message = `Client change requests denied!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        commit('updateViewedShift', shift)
        resolve(shift)
      },
      error => {
        const message = `Something went wrong denying the changes...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject(error)
      })
    })
  },

  pickUp ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.pickUp(params, shift => {
        const message = `You've picked up the ${ shift.location } ${ shift.shiftRole } shift!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong picking up that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  destroy ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.destroy(params, shift => {
        const message = `Shift Deleted!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('removeShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong deleting that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  approve ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.approve(params, shift => {
        const message = `Published!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong approving that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  disapprove ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.disapprove(params, shift => {
        const message = `Unpublished!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('updateShift', shift)
        resolve()
      },
      error => {
        const message = `Something went wrong disapproving that shift...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },

  createNote ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.createNote(params, note => {
        const message = `Note created!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('refreshNote', note)
        resolve(note)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  updateNote ({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      shiftApi.updateNote(idFieldData, note => {
        commit('refreshNote', note)
        resolve(note)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  refreshNotes ({ dispatch, commit }, note) {
    commit('refreshNote', note)
  },

  setOwned ({ commit }, shifts) {
    commit('setOwned', shifts)
  },

  addToOwned ({ commit }, shifts) {
    commit('addToOwned', shifts)
  },

  setShifts ({ commit }, shifts) {
    commit('setShifts', shifts)
  },

  setShiftNotes ({ commit }, notes) {
    commit('setShiftNotes', notes)
  },

  setViewedShift ({ commit }, shift) {
    commit('setViewedShift', shift)
  },

  setAvailable ({ commit }, shifts) {
    commit('setAvailable', shifts)
  },

  addToAvailable ({ commit }, shifts) {
    commit('addToAvailable', shifts)
  },
}

// mutations
const mutations = {
  setAvailable (state, shifts) {
    state.available = shifts
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },

  updateShift (state, shift) {
    state.shifts = [
      ...state.shifts.filter(s => s.id !== shift.id),
      shift
    ]
  },

  updateShifts (state, shifts) {
    shifts.forEach((newShift) => {
      const oldShift = state.shifts.find(s => s.id == newShift.id)
      Object.assign(oldShift, newShift)
    })
  },

  refreshNote (state, note) {
    state.notes = [
      ...state.notes.filter(n => n.id !== note.id),
      note
    ]
  },

  updateViewedShift (state, shift) {
    state.viewedShift = shift
  },

  removeShift (state, shift) {
    state.shifts = [
      ...state.shifts.filter(s => s.id !== shift.id)
    ]
  },

  setShifts (state, shifts) {
    state.shifts = shifts
  },

  setShiftNotes (state, notes) {
    state.notes = notes
  },

  addToAvailable (state, shifts) {
    state.available = state.available.concat(shifts)
  },

  setOwned (state, shifts) {
    state.owned = shifts
  },

  setCurrentUserCurrentShift (state, shift) {
    state.currentUserCurrentShift = shift
  },

  setCurrentUserNextShift (state, shift) {
    state.currentUserNextShift = shift
  },

  setCurrentUserLastShift (state, shift) {
    state.currentUserLastShift = shift
  },

  addToOwned (state, shifts) {
    state.owned = state.owned.concat(shifts)
  },

  setViewedShift (state, shift) {
    state.viewedShift= shift
  },


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
